<div class="dialog-header">
  <h2 mat-dialog-title>Important Account Notice</h2>
  <button mat-icon-button class="close-button" (click)="onCloseClick()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <p>Your account has been suspended due to a risk review. You can still view your program details, manage users, and make payments. For more information, please contact Transend Support.</p>
</mat-dialog-content>

<mat-dialog-actions class="form-actions">
  <button mat-flat-button class="ok-button" color="primary" (click)="onOkClick()">OK</button>
  <!--<button mat-flat-button class="cancel-button" (click)="onCancelClick()">Cancel</button>-->
</mat-dialog-actions>
